import { useLazyQuery } from "@apollo/client";

import { CarrierConfigurationSelectOptionsQuery } from "../../../graphql/deliveryService/queries/carrierConfigurationSelectOptions";

interface CarrierConfigurationSelectOption {
  id: string;
  label: string;
  value: string;
}

interface UseCarrierConfigurationSelectOptionsQueryProps {
  dataAction: (collection: {
    data: CarrierConfigurationSelectOption[];
  }) => void;
}

const useCarrierConfigurationSelectOptionsQuery = (
  props: UseCarrierConfigurationSelectOptionsQueryProps,
) => {
  const { dataAction } = props;

  const [query] = useLazyQuery(CarrierConfigurationSelectOptionsQuery, {
    onCompleted: (data) => {
      dataAction({
        data: data?.carrierConfigurationSelectOptions || [],
      });
    },
    onError: (error) => {
      console.error("Error fetching carrier configuration options:", error);
    },
  });

  return [query] as const;
};

export default useCarrierConfigurationSelectOptionsQuery;
